import { CANCEL_PAY_REQUEST_MESSAGE_TYPE, ECHO_MESSAGE_TYPE, ORDER_COMPLETE_MESSAGE_TYPE, PAY_REQUEST_MESSAGE_TYPE, paymentRealmType, postMessageType } from "../recoil/type";
import { getEncryptObject } from "../utils/crypto";



const MessageController = {


  getPayApprovalRequestData : (amount:number)=>{
    let payRequestData: postMessageType = {
      type: PAY_REQUEST_MESSAGE_TYPE,
      data: {
        amount,
        requested_at: new Date(),
      },
    };

    let payEncryptMessage = getEncryptObject(payRequestData);

    return payEncryptMessage;
  },

  getPayCancelRequestData : (payment:paymentRealmType)=>{
    let payRequestData: postMessageType = {
      type: CANCEL_PAY_REQUEST_MESSAGE_TYPE,
      data: payment,
    };

    let payEncryptMessage = getEncryptObject(payRequestData);

    return payEncryptMessage;
  },

  getOrderCompleteData : ()=>{
    let requestData: postMessageType = {
      type: ORDER_COMPLETE_MESSAGE_TYPE,
      data:{}
    };

    let payEncryptMessage = getEncryptObject(requestData);

    return payEncryptMessage;
  },


  getEchoData : (data:any)=>{
    let requestData: postMessageType = {
      type: ECHO_MESSAGE_TYPE,
      data
    };

    let payEncryptMessage = getEncryptObject(requestData);

    return payEncryptMessage;
  }

  
};

export default MessageController;
